
if(typeof FN == 'undefined') FN = {};



var iosBehavior = false;
var contentsVisible = false,
	  contentsDelay = false,

    socialOffset,
    socialLimit,
    socialSpacing;


$(window).on('load', function(){
  if (iosBehavior != true && $('#sidebar').outerHeight(true) < $('#content').outerHeight(true))
  {
		socialOffset = $('#sidebar div.social').offset().top;
		socialLimit = $('#read').offset().top + $('#read').height() - 21;
		socialSpacing = 15;

		socialScroll();
		$(window).scroll(function(){
			socialScroll();
		});
	}
});


function socialScroll()
{
	if ($(document).scrollTop() >= socialOffset - socialSpacing + 1)
		$('#sidebar div.links').addClass('fixed');
	else
		$('#sidebar div.links').removeClass('fixed');

	if ($(document).scrollTop() >= socialLimit - socialSpacing)
		$('#sidebar div.social').addClass('limit').css('top', socialLimit - socialOffset);
	else
		$('#sidebar div.social').removeClass('limit').css('top', socialSpacing);
}





$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var contentAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.body--default .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'content' }
    },
    /* Social Share */
    { 'config': { 'selector': '#sharing-sidebar .social-button--twitter.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'sidebar/twitter' }
    },
    { 'config': { 'selector': '#sharing-sidebar .social-button--facebook.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'sidebar/facebook' }
    },
    { 'config': { 'selector': '#sharing-sidebar .social-button--.analytics--click' },
      'event':  { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'sidebar/linkedin' }
    },
    /* Header + Footer Links to Tower Site */
    { 'config': { 'selector': '.nav-top .logo .analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'top-navigation/tower-logo' }
    },
    { 'config': { 'selector': '#about__wrapper .analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'footer/about' }
    },
    /* Various Page Interactions */
    { 'config': { 'selector': '#desktop-gui-ebook-notice .link--switch-to-desktop.analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'switch-to-desktop', 'eventLabelSuffix': 'cli-to-desktop' }
    },
    /* Cheat Sheet Download Buttons */
    { 'config': { 'selector': '.incentive-download--incentive_cheatpackage .analytics--click' },
      'event':  { 'eventCategory': 'content', 'eventAction': 'download', 'eventLabelSuffix': 'cheat-sheet-package' }
    }
  ];
  FN.analytics.addConfiguredEvents(contentAnalyticsEvents);


  /*********** Sharing Sidebar */
  FN.sharingBar.init({
    containerCssSelector: '#sharing-sidebar',
    topThresholdCssSelector: ($('#chapter h1:first-of-type').length > 0) ? '#chapter h1:first-of-type' : '#chapter h2:first-of-type'
  });


	// Initialize Lightbox
  $('#chapter').magnificPopup({
		delegate: 'a.zoom',
		type: 'image',
		gallery: {enabled: true},
    closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close"></button>',

		removalDelay: 300,
		mainClass: 'mfp-fade',

		callbacks: {
		    buildControls: function(){
				this.contentContainer.append(this.arrowLeft).append(this.arrowRight);
		    }
		}
	});
});
